<template>
    <div>
        <ul class="list-inline m-0">
            <li class="list-inline-item m-0" v-show="this.total >= 0">
                <i class="far fa-star-half font-yellow" v-if="this.total == 0"></i>
                <i class="fas fa-star font-yellow" v-if="this.total >= 1"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 0.5"></i>
            </li>
            <li class="list-inline-item m-0" v-show="this.total >= 1.5">
                <i class="fas fa-star font-yellow" v-if="this.total >= 2"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 1.5"></i>
            </li>
            <li class="list-inline-item m-0" v-show="this.total >= 2.5">
                <i class="fas fa-star font-yellow" v-if="this.total >= 3"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 2.5"></i>
            </li>
            <li class="list-inline-item m-0" v-show="this.total >= 3.5">
                <i class="fas fa-star font-yellow" v-if="this.total >= 4"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 3.5"></i>
            </li>
            <li class="list-inline-item m-0" v-show="this.total >= 4.5">
                <i class="fas fa-star font-yellow" v-if="this.total >= 5"></i>
                <i class="fas fa-star-half-alt font-yellow" v-else-if="this.total > 4.5"></i>
            </li>

            <li class="list-inline-item m-0 font-yellow">{{total.toFixed(1)}}</li>
        </ul>
    </div>
</template>
<style scoped>
    .list-inline li{
        font-size: 10px
    }
</style>
<script>
export default {
    name: 'Rating',
    props:{
        students: Number,
        rating: Number
    },
    data() {
        return {
            total: 0,
        }
    },
    mounted(){
        let total = this.rating / this.students
        if(total >= 0){
            this.total = total
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/#public/curse/components/home/RatingMin.vue